import { useDispatch } from "react-redux"

import { markEventTransactionsRead as markEventTransactionsReadGlobally } from "../../../reducer"

export function useNotificationUtils() {
  const dispatch = useDispatch()

  function getHasUnreadTransactions(event) {
    return event.transactions.filter((tx) => !tx.read).length > 0
  }

  function markEventTransactionsRead(candidate, setCandidate, event) {
    if (event.transactions.filter((tx) => !tx.read).length === 0) {
      return
    }
    setCandidate({
      ...candidate,
      crm_events: candidate.crm_events.map((e) =>
        e.id === event.id
          ? {
              ...event,
              transactions: event.transactions.map((tx) => ({
                ...tx,
                read: true,
              })),
            }
          : e
      ),
    })
    dispatch(markEventTransactionsReadGlobally(event))
  }

  return { getHasUnreadTransactions, markEventTransactionsRead }
}
